import { HttpInterceptorFn } from '@angular/common/http';

import { environment } from 'src/environments/environment';

/**
 * Attaches the Auth0 delegate token to requests bound for marketing-api.
 *
 * `@brafton/marketing-api-client-angular` ships no interceptor (a token is the application's
 * concern), so this does what `catalogAuthInterceptor` does for catalog-api: read the delegate
 * token `BfAuthService` stored under `id_token_delegate_<appName>` and add it as a bearer.
 * Requests to any other host pass through untouched, so the token never leaves for another API.
 *
 * No token (the delegate client is not provisioned yet, or the user lacks it) means no header;
 * marketing-api then answers 401, which the Sitelens view shows as its error message.
 */
export const marketingAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const endpoint = environment['marketing:Api:Endpoint'];
  const appName = environment['marketing:Api:Auth0:AppName'];
  if (!endpoint || !appName) {
    return next(req);
  }

  let sameHost = false;
  try {
    sameHost = new URL(req.url, location.origin).host === new URL(endpoint).host;
  } catch {
    // A malformed URL is somebody else's problem; do not attach a token to it.
  }
  if (!sameHost) {
    return next(req);
  }

  const token = localStorage.getItem(`id_token_delegate_${appName}`);
  return next(token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req);
};
